import TagManager from "./TagManager";



export default function TagSwitcher() {
    return (
      <div style={{ display: "flex"}}>
        <TagManager type="tag" />
        <TagManager type="multi_tag" />
        <TagManager type="double_tag" />
      </div>
    );
  }